import toast from "@components/toast/toast"
import _http_v1 from "../../../../../../http_requests/_http_v1"
import ButtonsComponent from "./buttons_component"
import List from "./list"

export default function ListController(){
    let modal_id = "#modal_views_list"
    let _list = new List({container:'.views-list-container'})
    BaseConstructor.call(this)
    let context = this
    init()

    this.show = () =>{
        $(modal_id).modal('show')
    }
    this.hide = () =>{
        $(modal_id).modal('hide')
    }
    this.reload = _ =>{
        this.show()
        buildList()
    }

    function buildList(){
        _list.loading()
        _http_v1.request('parameters', 'get', {parameter_type: 'ChartProductView', from_current_user:true, order_by: 'parameters.created_at asc'}).then(data=>{
            _list.generate(data)
        })
    }

    function destroyView(parameter_id){
        _http_v1.request(`parameters/${parameter_id}`, 'DELETE', {}).then(_=>{
            toast.success({text: "View removida!"})
            context.reload()
        })
    }

    function init(){
        $('.views-list-buttons').html('')
        
        buildList()
        
        _list.on('edit_parameter', parameter =>{
            context.trigger('edit_parameter', parameter)
        })

        _list.on('use_view', parameter =>{
            context.trigger('use_view', parameter)
        })

        _list.on('destroy_view', parameter_id=>{
            destroyView(parameter_id)
        })

        let buttonsComponent = new ButtonsComponent({container: '.views-list-buttons'})
        buttonsComponent.generate()

        buttonsComponent.on('create-new-view', _=>{
            context.trigger('new-parameter')
        })
    }
}

ListController.prototype = Object.create(BaseConstructor.prototype)